import React, { Component } from 'react';
import { Button, Menu, Dropdown, message, Popconfirm, Row, Col } from "antd";
import { inject, observer } from "mobx-react";
import "./personal.scss";
import moment from "moment";
import ApplyBilling from "./ApplyBilling";
import Logistics from "./Logistics";
import ApplicationContract from "./ApplicationContract";
import FileSaver from "file-saver";
import hotelimg from "../../assets/mine/酒店名称.png";
import set from "../../assets/mine/系统管理员.png";
import time from "../../assets/mine/系统管理员 copy.png";
import area from "../../assets/mine/区域.png";
import wdmnum from "../../assets/mine/number.png";

const code = {
    1: "等待客户支付！",
    2: "支付成功！",
    3: "支付失败！",
    4: "支付结果异常!",
};

@inject('store')
@observer
class personal extends Component {
    state = {
        user: {},
        logs: [],
        hotel: {},
        expressData: {}
    };

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        fetch('/getHotelPay', { credentials: 'include' }).then(x => x.json()).then(x => {
            this.setState({
                user: x.data.user || {},
                logs: (x.data.logs || []).reverse(),
                hotel: x.data.hotel || {},
            });
        }).catch(err => {
            console.error(err);
        })
    }

    getBilling = (item) => {
        if (item.status != 2) return;

        if (item.is_billing != 1) {
            return <span className="apply">
                <span
                    onClick={() => this.props.store.applybilling.onShow(item)}
                >申请开票</span>
            </span>
        };

        if (item.is_billing == 1 && (item.express_no)) {
            return <span className="invoiced">已开票</span>
        }

        if (item.is_billing == 1 && (item.url)) {
            return <span className="apply">
                <span
                    onClick={() => {
                        FileSaver.saveAs(item.url)
                    }}
                >下载发票</span>
            </span>
        }

        if (item.is_billing == 1 && !item.express_no) {
            return <span className="invoiced">发票已申请</span>
        }
    }

    getExpress = (item) => {
        if (item.status != 2 || item.is_billing != 1 || !item.express_no) return;
        return <span onClick={() => {
            this.setState({ expressData: item });
            this.props.store.applyexpress.onShow();
        }}>查看物流</span>
    }

    getContract = (item) => {
        if (item.status == 2) return;
        return <span className="apply">
            <span
                onClick={() => this.props.store.applycontract.onShow(item, this.state.hotel)}
            >申请合同</span>
        </span>
    }

    onDeleteApply = (item) => {
        if (item.status == 2) {
            message.error('已完成的订单不支持删除');
            return
        }
        fetch('/onDeleteApply?id=' + item.id, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.status == 1) {
                message.info('删除成功！');
                this.getData();
                return
            }
            message.error(x.msg);
        }).catch(err => {
            console.error(err);
        })
    }

    onMore = (item) => {
        const menu = (
            <Menu>
                <Menu.Item>
                    <Popconfirm
                        title="请确认未使用此订单付款?"
                        onConfirm={this.onDeleteApply.bind(this, item)}
                        okText="确定"
                        cancelText="取消"
                    >
                        <span>
                            删除
                        </span>
                    </Popconfirm>

                </Menu.Item>
            </Menu>
        );
        return <Dropdown overlay={menu}>
            <a className="ant-dropdown-link"  >
                更多操作
            </a>
        </Dropdown>
    }

    render() {
        const { user = {}, logs = [], hotel = {}, expressData = {} } = this.state;
        console.log("hotel:", logs);
        return (
            <div className="personal">
                <div className="basic">
                    <div >基本信息</div>
                </div>
                <Row type="flex" justify="space-between">
                    <Col span={8} className="detail-list">
                        <div>
                            <img src={hotelimg} alt="" />
                            <span>酒店名称</span>
                        </div>

                        <div>{hotel.name || ""}</div>
                    </Col>
                    <Col span={8} className="detail-list">
                        <div>
                            <img src={wdmnum} alt="" />
                            <span>温德姆编码</span>
                        </div>

                        <div>{hotel.wdm_number || ""}</div>
                    </Col>
                    <Col span={8} className="detail-list">
                        <div>
                            <img src={wdmnum} alt="" />
                            <span>千乘编码</span>
                        </div>

                        <div>{hotel.code || ""}</div>
                    </Col>
                </Row>

                <div className="detail-list">
                    <div>
                        <img src={set} alt="" />
                        <span>登录账号</span>
                    </div>
                    <div>
                        <span>{user.name}</span>
                        {(
                            (user.email || "").includes('admin')
                            ||
                            (user.email || "").includes('GM')
                        )
                            &&
                            <Button type="primary" onClick={() => {
                                this.props.history.push(`/table/hotel/${hotel.id}`);
                            }}>
                                查看酒店账号
                            </Button>
                        }
                    </div>
                </div>
                <div className="detail-list">
                    <div>
                        <img src={time} alt="" />
                        <span>付费过期时间</span>
                    </div>
                    <div>
                        <span>{moment(hotel.expire_date || "2019-07-01").format('YYYY-MM-DD')}</span>
                        <Button type="primary" onClick={() => {
                            this.props.history.push('/pay')
                        }}>
                            续费
                        </Button>
                    </div>
                </div>

                <div className="basic logs">
                    <div >支付记录</div>
                </div>
                {
                    (logs).map((item, i) => {
                        return (
                            <div className="log-list" key={item.id}>
                                <div className={i == 0 ? "first" : ""}>{i != (logs.length - 1) ? <div style={{ top: i == 0 ? 22 : 20 }}></div> : ""}</div>
                                <span>{moment(item.add_time).format('YYYY-MM-DD')}</span>
                                <span>{item.out_trade_no}</span>
                                <span>{code[item.status]}</span>
                                {this.getBilling(item)}
                                {this.getExpress(item)}
                                {/* 申请合同 */}
                                {this.getContract(item)}
                                {/* 支付宝支付 */}
                                {this.onMore(item)}
                            </div>
                        )
                    })
                }
                <ApplyBilling getData={this.getData} />
                <Logistics data={expressData} />
                <ApplicationContract />
            </div >
        );
    }
}

export default personal;


// WEBPACK FOOTER //
// ./src/components/user/personal.js